// src/hooks/useOverallReduction.js
import { useMemo } from "react";
import { useSectorEmissionsTS } from "./useSectorEmissionsTS"; // the GraphQL hook

function pctReduction(fromVal, toVal) {
  if (typeof fromVal !== "number" || !isFinite(fromVal) || fromVal === 0) return 0;
  return ((fromVal - toVal) / fromVal) * 100;
}

export function useOverallReduction({ scenario, from = 2020, to = 2050, compareYear = 2025 }) {
  const { labels, seriesBySector, loading, error } = useSectorEmissionsTS({ scenario, from, to });

  const result = useMemo(() => {
    if (!labels.length) return { totalPct: 0, baselineYear: compareYear, targetYear: to };

    const baseIdx = labels.includes(compareYear) ? labels.indexOf(compareYear) : 0;
    const tgtIdx  = labels.includes(to) ? labels.indexOf(to) : labels.length - 1;

    const keys = ["food", "buildings", "transport", "industry"];

    const baseTotal = keys.reduce((sum, k) => {
      const v = seriesBySector[k]?.[baseIdx];
      return sum + (typeof v === "number" ? v : 0);
    }, 0);

    const tgtTotal = keys.reduce((sum, k) => {
      const v = seriesBySector[k]?.[tgtIdx];
      return sum + (typeof v === "number" ? v : 0);
    }, 0);

    const totalPct = pctReduction(baseTotal, tgtTotal);

    return {
      totalPct: isFinite(totalPct) ? totalPct : 0,
      baselineYear: labels[baseIdx],
      targetYear: labels[tgtIdx],
    };
  }, [labels, seriesBySector, compareYear, to]);

  return { ...result, loading, error };
}

